<template>

    <div class="fan-control">
          <el-button plain type="primary" @click="connectDevice" v-if="!connected" size="small">连接设备</el-button>
          <el-button plain type="danger" @click="disconnectDevice" v-if="connected" size="small">断开连接</el-button>
          <el-button plain type="danger" @click="rxData=''" size="small">清空</el-button>
        <div class="status">           
            <el-input
                v-model="rxData"
                style="width: 100%"
                :rows="10"
                
                readonly
                type="textarea"                
                clearable
            />            
           
        </div>
        <div>              
            <el-input
                v-model="txData"
                style="width: 240px"                
                clearable
                type="textarea" 
                :rows="2"
            />
            <el-button plain type="danger" @click="send" v-if="connected" size="small">发送</el-button> 
        </div>
        <div id="map" style="width:98%;height: 250px;"></div>
        <el-descriptions title="定位信息">

          <el-descriptions-item label="经度">{{ location.longitude?.toFixed(6)}}</el-descriptions-item>
          <el-descriptions-item label="纬度">{{location.latitude?.toFixed(6)}}</el-descriptions-item>
          <el-descriptions-item label="海拔">{{ location.altitude }} {{ location.altitudeUnits }}</el-descriptions-item>
          <el-descriptions-item label="水准面">{{ location.geoidHeight }} {{ location.geoidHeightUnits }}</el-descriptions-item>
          <el-descriptions-item label="卫星数量">{{location.satellitesInView}}</el-descriptions-item>
          <el-descriptions-item label="水平精度">{{location.hdop}}</el-descriptions-item>         
          <el-descriptions-item label="有效">{{location.isValid}}</el-descriptions-item>
          
        </el-descriptions>
        <div ref="echartRef0" style="width:98%; height: 300px;"></div>
        <div ref="echartRef" style="width:98%; height: 250px;"></div>
        <el-table :data="myArray" style="width: 100%">
            <el-table-column prop="system" label="" width="60"></el-table-column>
            <el-table-column prop="satId" label="卫星ID" >
              <template #default="scope">             
                  <div v-if="!prnList[scope.row.satId]">{{ scope.row.satId }}</div>   <el-tag v-if="prnList[scope.row.satId] && scope.row.azimuth && scope.row.snr" class="mx-1" type="success">{{ scope.row.satId }}</el-tag>           
              </template>
            </el-table-column>
            <el-table-column prop="elevation" label="俯仰角"></el-table-column>
            <el-table-column prop="azimuth" label="方位角"></el-table-column>
            <el-table-column prop="snr" label="信噪比"></el-table-column>
        </el-table>        
        <el-button plain type="danger" @click="clear()" size="small">清空</el-button>
    </div>

</template>

<script setup>

  import { ref, reactive,  onMounted } from 'vue'
  import { stringToBuffer,arrayBuffer2hex,hexToArrayBuffer} from '@/utils/hex.ts'
  import { loadScript } from '@/utils/loadjs.ts'
//   import { ElMessage } from 'element-plus'
  
  function arrayBufferToString(buffer, encoding = 'utf-8') {
    const decoder = new TextDecoder(encoding);
    const uint8Array = new Uint8Array(buffer);
    return decoder.decode(uint8Array);
}
const echartRef0 = ref(null)
const echartRef = ref(null)
const connected = ref(false)
const device = ref(null)

var T = window.T; // 这个一定需要定义，可以直接在mounted里面定义
let mapTD = null;
let marker = null;

const serviceUUID = '0000FFF0-0000-1000-8000-00805F9B34FB'.toLowerCase() // 默认心率服务
const char1UUID = '0000FFF1-0000-1000-8000-00805F9B34FB'.toLowerCase()
// 新增状态变量
const char2UUID = '0000FFF2-0000-1000-8000-00805F9B34FB'.toLowerCase() 

let server = null
let service = null 
let chart1 = null
let chart2 = null
let myChart0 = null
let myChart = null
let count = 0
const rxData = ref('')
const txData = ref('')
const command = ref('')
// const logs = reactive([])
const gsvList = {}
const prnList = {}

const location = reactive({})

const myArray = ref([]);

// 辅助函数：格式化时间 (hhmmss.ss -> hh:mm:ss)
        function formatTime(timeStr) {
            if (!timeStr || timeStr.length < 6) return '无效时间';
            
            const hours = timeStr.substring(0, 2);
            const minutes = timeStr.substring(2, 4);
            const seconds = timeStr.substring(4, 6);
            const milliseconds = timeStr.length > 6 ? timeStr.substring(7, 9) : '00';
            
            return `${hours}:${minutes}:${seconds}.${milliseconds}`;
        }
        
        // 辅助函数：解析坐标
        function parseCoordinate(value, direction, isLatitude) {
            if (!value || !direction) return null;
            
            // 确定坐标的度部分
            const degreesIndex = isLatitude ? 2 : 3;
            const degrees = parseFloat(value.substring(0, degreesIndex));
            const minutes = parseFloat(value.substring(degreesIndex));
            
            if (isNaN(degrees) || isNaN(minutes)) return null;
            
            // 转换为十进制
            let decimal = degrees + minutes / 60;
            
            // 根据方向调整符号
            if ((isLatitude && direction === 'S') || (!isLatitude && direction === 'W')) {
                decimal = -decimal;
            }
            
            return decimal;
        }
        
        // 辅助函数：解析定位质量
        function parseFixQuality(quality) {
            const qualities = {
                '0': '无效定位',
                '1': 'GPS定位',
                '2': '差分GPS定位',
                '3': 'PPS定位',
                '4': 'RTK固定解',
                '5': 'RTK浮点解',
                '6': '估计值'
            };
            
            return qualities[quality] || `未知定位质量 (${quality})`;
        }

function decodeGNGGA(sentence) {
    // 验证输入
    if (typeof sentence !== 'string') {
        throw new Error('输入必须是字符串');
    }
    
    // 分割语句
    const rawSentence = sentence.split('*')[0];
    const fields = rawSentence.split(',');    
    
    // 验证字段数量
    if (fields.length < 15) {
        return null;
    }
    
    // 解析各个字段
    Object.assign(location , {
        sentenceType: 'Global Navigation Satellite System Fix Data',
        raw: sentence,
        utcTime: fields[1], // 原始UTC时间字符串
        formattedTime: formatTime(fields[1]), // 格式化后的时间
        latitude: parseCoordinate(fields[2], fields[3], true), // 纬度（十进制）
        longitude: parseCoordinate(fields[4], fields[5], false), // 经度（十进制）
        fixQuality: {
            code: parseInt(fields[6], 10), // 定位质量代码
            description: parseFixQuality(fields[6]) // 定位质量描述
        },
        satellitesInView: parseInt(fields[7], 10) || 0, // 可见卫星数量
        hdop: parseFloat(fields[8]) || 0, // 水平精度因子
        altitude: parseFloat(fields[9]) || 0, // 海拔高度
        altitudeUnits: fields[10] || 'M', // 高度单位
        geoidHeight: parseFloat(fields[11]) || 0, // 大地水准面高度
        geoidHeightUnits: fields[12] || 'M', // 高度单位
        dgpsAge: fields[13] ? parseFloat(fields[13]) : null, // 差分时间
        dgpsStationId: fields[14] || null, // 差分站ID
        isValid: parseInt(fields[6], 10) > 0 // 定位是否有效
    });
    if(location.isValid){
        let point =new T.LngLat(location.longitude, location.latitude)
           // mapTD.clearOverLays()
            mapTD.centerAndZoom(point, mapTD.getZoom());
            if(marker == null){
                    //创建标注对象
                marker = new T.Marker(point);
                //向地图上添加标注
                mapTD.addOverLay(marker);
            }else{
                marker.setLngLat(point)
            }
    }
    return location
}

function decodeGNGSA(sentence) {
    // 输入验证
    if (typeof sentence !== 'string') {
        throw new Error('Input must be a string');
    }
    if (!sentence.startsWith('$GNGSA')) {
        throw new Error('Unsupported GSA type - must start with $GNGSA');
    }

    // 分割语句（移除校验部分）
    const parts = sentence.split('*')[0].split(',');
    if (parts.length < 18) {
        //console.log('eee',parts.length,sentence)
        //throw new Error('Invalid GSA format - not enough fields');
        return null
    }

    // 解析基本字段
    const mode1 = parts[1] || null;      // 工作模式
    const mode2 = parseInt(parts[2], 10); // 定位模式
    const satSystems = new Set();         // 检测到的卫星系统

    // 解析卫星PRN列表 (字段3-14)
    const satellites = [];
    for (let i = 3; i <= 14; i++) {
        if (parts[i] && parts[i] !== '') {
            const prn = parts[i];
            const prnNum = parseInt(prn)
            prnList[prnNum+''] = true
            satellites.push(prn);
            
            // 检测卫星系统类型
            if (prn.startsWith('G')) satSystems.add('GPS');
            if (prn.startsWith('R')) satSystems.add('GLONASS');
            if (prn.startsWith('B')) satSystems.add('BeiDou');
            if (prn.startsWith('E')) satSystems.add('Galileo');
            if (prn.startsWith('J')) satSystems.add('QZSS');
            if (prn.startsWith('I')) satSystems.add('IRNSS');
            if (/^\d/.test(prn)) satSystems.add('GPS'); // 纯数字PRN通常是GPS
        }
    }

    // 解析DOP值
    const pdop = parseFloat(parts[15]) || null;
    const hdop = parseFloat(parts[16]) || null;
    const vdop = parseFloat(parts[17]) || null;

    // 确定系统类型
    const system = satSystems.size > 0 
        ? Array.from(satSystems).join('/') 
        : 'Unknown';

    return {
        system,
        mode1,
        mode2,
        satellites,
        pdop,
        hdop,
        vdop,
        raw: sentence // 可选：保留原始语句
    };
}

function decodeGSV(sentence) {
    
    // 校验输入是否有效
    if (typeof sentence !== 'string') throw new Error('Input must be a string');
    // 分割语句（移除校验部分）
    const parts = sentence.split('*')[0].split(',');
    if (parts.length < 4) {       
        return null;
    }

    // 解析系统类型
    let system = sentence.substring(1,3);
    if(system == 'GB'){
      system = 'BD';
    }    
    // 解析基础信息
    const messageTotal = parseInt(parts[1], 10);
    const messageIndex = parseInt(parts[2], 10);
    const totalSats = parseInt(parts[3], 10);

    // 解析卫星数据（每4个字段一组）
    //const satellites = [];
    for (let i = 4; i + 3 < parts.length; i += 4) {
        const satId = parseInt(parts[i], 10) || null;
        const elevation = parseInt(parts[i + 1], 10) || null;
        const azimuth = parseInt(parts[i + 2], 10) || null;
        const snr = parseInt(parts[i + 3], 10) || null;
        
        // 跳过无效的卫星ID
        if (satId === null) continue;
        
        let s = {
            system,
            satId,
            elevation,
            azimuth,
            snr: snr === null ? null : Math.abs(snr) // 确保非负
        };

        gsvList[system+'-'+satId] = s;
    }
    myArray.value = Object.values(gsvList);
    //console.log(myArray.value)
    //return satellites;
}

const deviceInfo = reactive({
  name: '',
  id: ''
})

// 计算属性
//const connectionStatus = computed(() => connected.value ? '已连接' : '未连接')
//const canSend = computed(() => command.value.trim() !== '')

// 日志记录
const addLog = (message) => {
    console.log(message)
}
const clear = ()=>{
    Object.keys(gsvList).forEach(key => {
      delete gsvList[key];
    });
    myArray.value = Object.values(gsvList);
    update()
}
// 在handleNotifications中添加格式选择
const handleNotifications = (event) => {
  if(count % 200==0){
    rxData.value = ''
  }
  count++;
  const value = event.target.value
  const se  = arrayBufferToString(value.buffer)
  rxData.value+=se
  
  const arr = se.split('$')
  for(let line of arr){
    if (/^[B|G][B|P|D|A|Q|L]GSV/.test(line)){
       decodeGSV('$'+line)       
    }
    if(line.startsWith('GNGSA')){
        //console.log('gsa1',line)
       let obj= decodeGNGSA('$'+line)
       //console.log('gsa',obj)
    }
    if(line.startsWith('GNGGA')){      
       let obj= decodeGNGGA('$'+line)
      
    }
    //console.log(line)
  }
  update()
  //let data = arrayBuffer2hex(value.buffer)
  //console.log('recv data',data)
  //rxData.value+=data+'\r\n'
  //let json = JSON.parse(data)  
  //console.log('json',data)
 // addLog(`收到数据: ${data}`)
}

// 新增启用通知方法
const startNotifications = async () => {
  try {
  
    chart1.addEventListener('characteristicvaluechanged', handleNotifications)
    await chart1.startNotifications()
    
   
    addLog('通知功能已启用')
  } catch (error) {
    addLog(`启用通知失败: ${error}`)
  }
}

// 连接设备
const connectDevice = async () => {
  try {
    device.value = await navigator.bluetooth.requestDevice({
      acceptAllDevices: true,    
      optionalServices: [serviceUUID],
      // filters: [ 
      //   { namePrefix: 'GPS_' } 
      // ]
    })
    
    deviceInfo.name = device.value.name
    deviceInfo.id = device.value.id
    
    device.value.addEventListener('gattserverdisconnected', disconnectHandler)
    
    server = await device.value.gatt.connect()
    connected.value = true
    addLog(`已连接至设备: ${device.value.name}`)

    service = await server.getPrimaryService(serviceUUID)
    console.log('service',service)
    chart1 = await service.getCharacteristic(char1UUID)
    console.log('ch1',chart1)
    chart2 = await service.getCharacteristic(char2UUID)
    console.log('ch2',chart2)
    console.log('start',service,chart1,chart2)
    startNotifications()

  } catch (error) {
    addLog(`连接失败: ${error}`)
  }
}

// 断开连接处理
const disconnectHandler = () => {
  connected.value = false
  deviceInfo.name = ''
  deviceInfo.id = ''
  addLog('设备已断开连接')
}

// 主动断开连接
const disconnectDevice = () => {
  if (device.value?.gatt.connected) {
    device.value.gatt.disconnect()
  }
  connected.value = false
}


const send = ()=>{
    if(txData.value){
         const data = stringToBuffer(txData.value+'\r\n')          
         chart2.writeValue(data)
         console.log('send',data)
         addLog(`命令已发送: ${txData.value}`)
    }
}

// 发送命令
const sendCommand = async () => {
//   try {   
//     // 将命令转换为ArrayBuffer
//     const data = hexStringToArrayBuffer(command.value.trim())    
//     await dutyChar.writeValue(data)
//     addLog(`命令已发送: ${command.value}`)
//     command.value = ''
//   } catch (error) {
//     addLog(`发送失败: ${error}`)
//   }
}

// 十六进制字符串转ArrayBuffer
const hexStringToArrayBuffer = (hex) => {
  hex = hex.replace(/\s/g, '')
  if (hex.length % 2 !== 0) throw new Error('无效的十六进制字符串')
  
  const buffer = new Uint8Array(hex.length / 2)
  for (let i = 0; i < hex.length; i += 2) {
    buffer[i/2] = parseInt(hex.substr(i, 2), 16)
  }
  return buffer
}
const update = ()=>{
  const option = {
    // ECharts的配置项
    title: {
      text: 'GPS'
    },
    tooltip: {},
    legend: {
      data:['GP','BD','GA','GQ']
    },
    xAxis: {
      data: myArray.value.map(item=> { return item.system+item.satId})
    },
    yAxis: {},
    series: [{
      name: 'GP',
      type: 'bar',
      itemStyle: {
            color: '#409eff'
          },
      data: myArray.value.map(item=> { return {
          value: item.system=='GP'?item.snr:'-'          
        }})
    },{
      name: 'BD',
      type: 'bar',
      itemStyle: {
            color: '#f56c6c'
      },
      data: myArray.value.map(item=> { return {
          value: item.system=='BD'?item.snr:'-'          
        }})
    },{
      name: 'GA',
      type: 'bar',
      itemStyle: {
            color: '#67c23a'
      },
      data: myArray.value.map(item=> { return {
          value: item.system=='GA'?item.snr:'-'          
        }})
    },{
      name: 'GQ',
      type: 'bar',
      itemStyle: {
            color: '#e6a23c'
      },
      data: myArray.value.map(item=> { return {
          value: item.system=='GQ'?item.snr:'-'          
        }})
    }]
  };
  myChart.setOption(option)

  // const data = [];
  // for (let i = 0; i <= 10; i++) {
  //   let theta = (i / 100) * 360;
  //   let r = 5 * (1 + Math.sin((theta / 180) * Math.PI));
  //   data.push([r, theta]);
  // }
  // let pol = myArray.value.map(item=> { 
  //   return {
  //     name: item.system+item.satId,
  //     value: [90-item.elevation,item.azimuth], 
  //     itemStyle: {color: '#409eff'}
  //     }
  //   })
  
  let option0 = {
    title: {
      text: '星图'
    },
    legend: {
      data: ['GP','BD','GA','GQ']
    },
    polar: {},
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      }
    },
    angleAxis: {
      type: 'value',      
      min: 0,
      max:360,       
      startAngle: 90  // 调整起始角度，默认是 0（即 x 轴正方向）,// 比如设置为 90，则起始点为 y 轴正方向
    },
    radiusAxis: {
      axisLabel: {
        show: false
      },
      min: 0,
      max:90,
      splitLine: {
        showMinLine: false,
        show: false
      },
      axisLine: {
        show: false      
      },
      axisTick: {
        show: false
      }
    },
    series: [
      {
        coordinateSystem: 'polar',
        name: 'GP',
        type: 'scatter',
        itemStyle: {color: '#409eff'},
        data: myArray.value.filter(item => item.system=='GP').map(item=> { 
          return {
            name: item.system+item.satId,
            value: [90-item.elevation,item.azimuth]            
            }
          })
      },{
        coordinateSystem: 'polar',
        name: 'BD',
        type: 'scatter',
        itemStyle: {
            color: '#f56c6c'
        },
        data: myArray.value.filter(item => item.system=='BD').map(item=> { 
          return {
            name: item.system+item.satId,
            value: [90-item.elevation,item.azimuth]
            }
          })
      },{
        coordinateSystem: 'polar',
        name: 'GA',
        type: 'scatter',
        itemStyle: {color: '#67c23a'},
        data: myArray.value.filter(item => item.system=='GA').map(item=> { 
          return {
            name: item.system+item.satId,
            value: [90-item.elevation,item.azimuth]            
            }
          })
      },{
        coordinateSystem: 'polar',
        name: 'GQ',
        type: 'scatter',
        itemStyle: {color: '#e6a23c'},
        data: myArray.value.filter(item => item.system=='GQ').map(item=> { 
          return {
            name: item.system+item.satId,
            value: [90-item.elevation,item.azimuth]            
            }
          })
      }
    ]
  };
  myChart0.setOption(option0)
}
onMounted(()=>{

   loadScript('echarts.js')
      .then(() => {
         myChart = window.echarts.init(echartRef.value)
        myChart0  = window.echarts.init(echartRef0.value)
      })
      .catch(error => {
        console.error('Error loading script', error);
      });
    loadScript('//api.tianditu.gov.cn/api?v=4.0&tk=90c9e4c2a2643d6097cc7d73bb2c0a32')
      .then(() => {
          T = window.T; // 这个一定需要定义，可以直接在mounted里面定义
          mapTD = new T.Map('map'); // div的id
          // 传参中心点经纬度，以及放大程度
          mapTD.centerAndZoom(new T.LngLat(113.225718, 22.264533), 15);

          mapTD.enableScrollWheelZoom();// 启用滚轮放大缩小
      })
      .catch(error => {
        console.error('Error loading script', error);
      });

})
</script>

<style>
.device-info{
    width: 90%;
}

.fan-control {
  max-width: 700px;
  margin: 2rem auto;
  padding: 20px;
  background: #f5f5f5;
  border-radius: 10px;
  text-align: center;
}

.status {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.status-item {
  font-size: 1.2em;
}

.fan-container {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 20px auto;
}

.fan {
  width: 100%;
  height: 100%;
  position: relative;
  transition: filter 0.3s;
}

.blade {
  position: absolute;
  width: 40px;
  height: 100px;
  background: #607D8B;
  left: 50%;
  transform-origin: bottom;
  border-radius: 10px;
}

.blade:nth-child(1) { transform: translateX(-50%) rotate(0deg); }
.blade:nth-child(2) { transform: translateX(-50%) rotate(120deg); }
.blade:nth-child(3) { transform: translateX(-50%) rotate(240deg); }

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.controls {
  margin-top: 20px;
}

input[type="range"] {
  width: 80%;
  height: 10px;
  background: #ddd;
  border-radius: 5px;
}

.speed-percent {
  font-size: 1.5em;
  margin-top: 10px;
  color: #2196F3;
}


</style>s